import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import DosageCalculator from "@/pages/DosageCalculator";
import QualityControlPage from "@/pages/QualityControlPage";
import ContactPage from "@/pages/ContactPage";
import Admin from "@/pages/Admin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminBlogs from "@/pages/admin/AdminBlogs";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminPlaceholder from "@/pages/admin/AdminPlaceholder";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Account from "@/pages/Account";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import CartDrawer from "@/components/aeonyx/CartDrawer";
import AuthDialog from "@/components/auth/AuthDialog";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import AdminOnlyRoute from "@/components/auth/AdminOnlyRoute";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Landing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/success"
                element={
                  <ProtectedRoute>
                    <Success />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/quality"
                element={
                  <ProtectedRoute>
                    <QualityControlPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dosage"
                element={
                  <ProtectedRoute>
                    <DosageCalculator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/contact"
                element={
                  <ProtectedRoute>
                    <ContactPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin" element={<AdminOnlyRoute><Admin /></AdminOnlyRoute>} />
              <Route path="/admin/dashboard" element={<AdminOnlyRoute><AdminDashboard /></AdminOnlyRoute>} />
              <Route path="/admin/orders" element={<AdminOnlyRoute><AdminOrders /></AdminOnlyRoute>} />
              <Route path="/admin/blogs" element={<AdminOnlyRoute><AdminBlogs /></AdminOnlyRoute>} />
              <Route path="/admin/faqs" element={<AdminOnlyRoute><AdminFaqs /></AdminOnlyRoute>} />
              <Route path="/admin/products" element={<AdminOnlyRoute><AdminProducts /></AdminOnlyRoute>} />
              <Route path="/admin/categories" element={<AdminOnlyRoute><AdminPlaceholder title="Categories" description="Organize your storefront with categories." /></AdminOnlyRoute>} />
              <Route path="/admin/customers" element={<AdminOnlyRoute><AdminCustomers /></AdminOnlyRoute>} />
              <Route path="/admin/coupons" element={<AdminOnlyRoute><AdminCoupons /></AdminOnlyRoute>} />
              <Route path="/admin/analytics" element={<AdminOnlyRoute><AdminPlaceholder title="Analytics" description="Revenue, sales, and visitor charts." /></AdminOnlyRoute>} />
              <Route path="/admin/reviews" element={<AdminOnlyRoute><AdminPlaceholder title="Reviews" description="Approve, edit, and remove product reviews." /></AdminOnlyRoute>} />
              <Route path="/admin/messages" element={<AdminOnlyRoute><AdminMessages /></AdminOnlyRoute>} />
              <Route path="/admin/settings" element={<AdminOnlyRoute><AdminPlaceholder title="Settings" description="Store branding, tax, shipping, and payment settings." /></AdminOnlyRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <CartDrawer />
            <AuthDialog />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
